module.exports = __webpack_public_path__ + "static/media/icn-reports-selected.1cdf76e7.svg";